import { render } from "./PreviousButton.vue?vue&type=template&id=2422ad5b&scoped=true"
import script from "./PreviousButton.vue?vue&type=script&lang=js"
export * from "./PreviousButton.vue?vue&type=script&lang=js"

import "./PreviousButton.vue?vue&type=style&index=0&id=2422ad5b&scoped=true&lang=css"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2422ad5b"]])

export default __exports__